'use client'

import React from 'react'
import { ErrorBoundary } from './ErrorBoundary'
import { useRouter } from 'next/navigation'

interface RouteErrorBoundaryProps {
  children: React.ReactNode
}

/**
 * Route-level error boundary that logs errors and provides
 * navigation options tailored for page-level errors.
 */
export function RouteErrorBoundary({ children }: RouteErrorBoundaryProps) {
  const router = useRouter()

  const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
    // Log to console in development
    console.error('[RouteErrorBoundary] Error caught:', {
      error: error.message,
      stack: error.stack,
      componentStack: errorInfo.componentStack,
      timestamp: new Date().toISOString(),
      url: typeof window !== 'undefined' ? window.location.href : 'unknown',
    })

    // In production, you would send this to your error tracking service
    // Example: Sentry.captureException(error, { contexts: { react: { componentStack: errorInfo.componentStack } } })

    // You could also send to your own backend API
    if (process.env.NODE_ENV === 'production') {
      try {
        // Example: Send error to your backend
        // fetch('/api/log-error', {
        //   method: 'POST',
        //   headers: { 'Content-Type': 'application/json' },
        //   body: JSON.stringify({
        //     message: error.message,
        //     stack: error.stack,
        //     componentStack: errorInfo.componentStack,
        //     url: window.location.href,
        //     userAgent: navigator.userAgent,
        //     timestamp: new Date().toISOString(),
        //   }),
        // }).catch(console.error)
      } catch (e) {
        // Silently fail if error logging fails
        console.error('Failed to log error:', e)
      }
    }
  }

  return (
    <ErrorBoundary
      onError={handleError}
      showDetails={process.env.NODE_ENV === 'development'}
    >
      {children}
    </ErrorBoundary>
  )
}

export default RouteErrorBoundary
